import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {},
  error: null,
};

const { Types, Creators } = createActions(
  {
    getUserDetails: ['id'],                    
    getUserDetailsRequest: [],                 
    getUserDetailsSuccess: ['data'],           
    getUserDetailsFailure: ['error'],
  },
  { prefix: 'cb/admin/userManager/getUserDetails' },
);

export { Types as types, Creators as actions };

export const request = state => ({
  ...state,
  fetching: true,
  fetched: false,
  data: {},
  error: null,
});

export const success = (state, action) => {
  const { data } = action;
  return {
    ...INITIAL_STATE,
    fetched: true,
    data,
  };
};

export const failure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetching: false,
    fetched: true,
    error,
  };
};


export const HANDLERS = {
  [Types.GET_USER_DETAILS_REQUEST]: request,       
  [Types.GET_USER_DETAILS_SUCCESS]: success,       
  [Types.GET_USER_DETAILS_FAILURE]: failure, 
};

export default createReducer(INITIAL_STATE, HANDLERS);
